export default function HandleHomePageError(navigate,status) {
    if (status >= 400 && status <= 405) {
        navigate(`${process.env.PUBLIC_URL}/login/pages/error/error-page1`);
    } else if (status >= 500 && status <= 505) {
        navigate(`${process.env.PUBLIC_URL}/login/pages/error/error-page4`);
    } else {
        navigate(`${process.env.PUBLIC_URL}/login/pages/error/error-page3`);
    }
};
